class ElementComponentData {
	constructor() {
		this.enabled = true;
	}
}

export { ElementComponentData };
